import { createGlobalStyle, css } from 'styled-components';

export const BlcLayoutGlobalStyle = createGlobalStyle`

* {
	box-sizing: border-box;
	font-smoothing: antialiased;
	text-stroke: 0.45px rgba(0, 0, 0, 0.1);
}


${({ fullHeight, background }) => css`
	body > #__next {
		${fullHeight ?
			`
		height: 100%;
		display: flex;
		flex-direction: column;
	`
		:	''}
	}

	.full-height-layout {
		${fullHeight ?
			`
		flex: 1;
		min-height: 0;
		overflow: auto;
	`
		:	''}
	}

	html {
		scroll-behavior: smooth;
		${fullHeight ? `height: 100%;` : ''}
	}

	body {
		margin: 0;
		overflow-x: hidden;
		padding: 0;
		${background ? `background: ${background};` : ''}
		${fullHeight ? `height: 100%;` : ''}
	}
`}
`;
